import { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { parse } from 'querystringify'

// Utils
import { isChrome } from '@constants'

type ScrollToTopProps = {
  location: {
    search: string
    hash: string
  }
  children: JSX.Element[]
}

const rafAsync = () =>
  new Promise(r => {
    requestAnimationFrame(r)
  })

const checkElement = (selector: string) => {
  if (document.getElementById(selector) === null) {
    return rafAsync().then(() => checkElement(selector))
  }
  return Promise.resolve(true)
}

let prevQuery = false
class ScrollToTop extends Component<ScrollToTopProps> {
  componentDidMount() {
    this.scrollToHash(true)
  }

  componentDidUpdate(prevProps) {
    const {
      location,
      location: { search, hash },
    } = this.props
    const currentQuery = parse(search)
    const wasModal = currentQuery.hasOwnProperty('modal') || prevQuery.hasOwnProperty('modal')
    prevQuery = currentQuery

    if (!wasModal && location !== prevProps.location && !hash) {
      return window.scrollTo(0, 0)
    }

    if (hash && !currentQuery.modal) {
      return this.scrollToHash(false)
    }

    return false
  }

  scrollToHash = isMount => {
    const {
      location: { search, hash },
    } = this.props

    const query = parse(search)
    if (hash && !query.modal) {
      const hashName = Object.keys(parse(hash)).find(x => x.startsWith('#'))
      const elem = hashName ? hashName.replace('#', '') : ''
      checkElement(elem).then(() => {
        const element = document.getElementById(elem)

        const bodyRect = document.body && document.body.getBoundingClientRect()
        const elemRect = element && element.getBoundingClientRect()
        const offset = elemRect && bodyRect ? elemRect.top - bodyRect.top : 0
        const delay = isChrome() && isMount ? 1000 : 1

        // scroll to element offset by 100px
        setTimeout(() => window.scrollTo(0, offset - 100), delay)
      })
    }
  }

  render() {
    return this.props.children
  }
}

export default withRouter(ScrollToTop)
